import React from 'react'
import { useLocation, Routes, Route, Link } from 'react-router-dom'
import styled from 'styled-components'
import ApiSettings from '../components/settings/config/ApiSettings'
import Web3Settings from '../components/settings/config/Web3Settings'
import TokenRegistry from '../components/settings/config/TokenRegistry'
import Notifications from '../components/settings/config/Notifications'
import RelayerExecutorForm from '../components/settings/config/RelayerExecutorForm'
import ReportsSettingsForm from '../components/settings/config/ReportsSettingsForm'
import Users from '../components/settings/UserList'
import Crons from '../components/settings/Crons'
import Subgraphs from '../components/settings/Subgraphs'
import Logs from '../components/settings/logs/Logs'
import LogsGroup from '../components/settings/logs/LogsGroup'
import LogsItem from '../components/settings/logs/LogsItem'
import Registry from '../components/settings/Registry'
import Networks from '../components/settings/network/NetworksPage'
import Rpcs from '../components/settings/network/Rpcs'
import Pods from '../components/settings/Pods'
import { PriceOracleSettings } from '../components/settings/config/PriceOracle'

export default function Settings() {
  return (
    <Wrap>
      <PageTitle>General</PageTitle>
      <TabBar>
        <TabLink to="config">Config</TabLink>
        <TabLink to="registry">Registry</TabLink>
        <TabLink to="users">Users</TabLink>
        <TabLink to="networks">Networks</TabLink>
        <TabLink to="rpcs">RPCs</TabLink>
        <TabLink to="subgraphs">Subgraphs</TabLink>
        <TabLink to="crons">Crons</TabLink>
        <TabLink to="pods">Pods</TabLink>
        <TabLink to="logs">Logs</TabLink>
      </TabBar>
      <Content>
        <Routes>
          <Route path="config/*" element={<ConfigTab />} />
          <Route path="registry/*" element={<Registry />} />
          <Route path="users/*" element={<Users />} />
          <Route path="networks/*" element={<Networks />} />
          <Route path="rpcs/*" element={<Rpcs />} />
          <Route path="subgraphs/*" element={<Subgraphs />} />
          <Route path="crons/*" element={<Crons />} />
          <Route path="pods/*" element={<Pods />} />
          <Route path="logs/groups/*" element={<LogsGroup />} />
          <Route path="logs/:id/groups/*" element={<LogsItem />} />
          <Route path="logs/*" element={<Logs />} />
          <Route path="/" element={<ConfigTab />} />
        </Routes>
      </Content>
    </Wrap>
  )
}

function ConfigTab() {
  return (
    <ConfigWrap>
      <SectionGroup>
        <SectionLabel>Relayer Executor</SectionLabel>
        <RelayerExecutorForm />
      </SectionGroup>
      <SectionGroup>
        <SectionLabel>Web3</SectionLabel>
        <Web3Settings />
      </SectionGroup>
      <SectionGroup>
        <SectionLabel>Price Oracle</SectionLabel>
        <PriceOracleSettings />
      </SectionGroup>
      <SectionGroup>
        <SectionLabel>Token Registry</SectionLabel>
        <TokenRegistry />
      </SectionGroup>
      <SectionGroup>
        <SectionLabel>Notifications</SectionLabel>
        <Notifications />
      </SectionGroup>
      <SectionGroup>
        <SectionLabel>API</SectionLabel>
        <ApiSettings />
      </SectionGroup>
      <SectionGroup>
        <SectionLabel>Reports</SectionLabel>
        <ReportsSettingsForm />
      </SectionGroup>
    </ConfigWrap>
  )
}

const TabLink = ({ to, children }: { to: string; children: React.ReactNode }) => {
  const location = useLocation()
  const isActive = (to === 'config' && location.pathname === '/dashboard/settings') || location.pathname.includes(to)

  return (
    <StyledLink to={`/dashboard/settings/${to}`} className={isActive ? 'active' : ''}>
      {children}
    </StyledLink>
  )
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`

const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #ededed;
  margin: 0 0 20px;
`

const TabBar = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  margin-bottom: 24px;
  flex-wrap: wrap;
`

const StyledLink = styled(Link)`
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #777;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s, border-color 0.15s;

  &:hover { color: #a0a0a0; }

  &.active {
    color: #a89aff;
    border-bottom-color: #6f5ce6;
  }
`

const Content = styled.div``

const ConfigWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const SectionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const SectionLabel = styled.h2`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #777;
  margin: 0;
`
